<p-dialog [resizable]="false"
  [(visible)]="visible"
  (onShow)="onShow()"
  (onHide)="close()"
  [modal]="true"
  [style]="{width: '440px'}"
  [draggable]="false"
  [showHeader]="true"
  [header]="'Review' | translate"
  [dismissableMask]="true"
  [closable]="true"
  [appendTo]="'body'">

  <div class="review-body">
    <p class="review-subtitle">{{ 'Rate this recommendation' | translate }}</p>

    <div class="star-rating-modal-stars">
      @for (star of starsArray; track star) {
        <span
          class="star-icon-modal"
          [class.star-filled]="star <= (hoveredStar() || selectedStar())"
          [class.star-empty]="star > (hoveredStar() || selectedStar())"
          (mouseenter)="onStarHover(star)"
          (mouseleave)="onStarLeave()"
          (click)="onStarClick(star)"
        >★</span>
      }
    </div>

    @if (hoveredStar() || selectedStar()) {
      <span class="review-label">{{ hoveredStar() || selectedStar() }} / 5</span>
    }

    <div class="review-comment">
      <app-textarea
        [label]="'Comment'"
        [placeholder]="'Comment'"
        [rows]="3"
        [autoResize]="true"
        [maxlength]="commentMaxLength"
        [showCharacterCount]="false"
        [ngModel]="comment()"
        (ngModelChange)="onCommentChange($event)"
      ></app-textarea>
      <span
        class="review-comment-counter"
        [class.review-comment-counter--invalid]="showCommentHint()"
      >
        {{ commentLength() }} / {{ commentMaxLength }}
        ·
        {{ 'STAR_RATING_COMMENT_MIN' | translate:{ count: commentMinLength } }}
      </span>
      @if (selectedStar() > 0 && isCommentTooShort()) {
        <span class="review-comment-hint">
          {{ 'STAR_RATING_COMMENT_TOO_SHORT' | translate:{ count: commentMinLength } }}
        </span>
      } @else if (selectedStar() > 0 && isCommentTooLong()) {
        <span class="review-comment-hint">
          {{ 'STAR_RATING_COMMENT_TOO_LONG' | translate:{ count: commentMaxLength } }}
        </span>
      } @else if (selectedStar() === 0) {
        <span class="review-comment-hint">
          {{ 'STAR_RATING_SELECT_RATING' | translate }}
        </span>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="review-actions w-full">
      <app-secondary-button
        [title]="'Cancel'"
        (action)="close()"
      ></app-secondary-button>
      <app-primary-button
        [title]="'Confirm'"
        [disable]="!canConfirm()"
        (action)="confirm()"
      ></app-primary-button>
    </div>
  </ng-template>

</p-dialog>
